import { render, staticRenderFns } from "./DetailModalDashboardPermohonan.vue?vue&type=template&id=42e5484e&"
import script from "./DetailModalDashboardPermohonan.vue?vue&type=script&lang=js&"
export * from "./DetailModalDashboardPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports